import { CHECKOUT_CUSTOMER_MISSING_LABEL_MAP } from '../constants'

export type ErrorType = 'pattern' | 'required' | 'minLength' | 'maxLength' | 'backendError'
interface GetFieldErrorMessageInput {
  type: ErrorType
  fieldConfigName: string
  fieldName: string
}

const specialErrorLabels = {
  required_cellPhone: 'checkout.delivery.phone.number.require',
  required_cardNumber: 'checkout.gift.card.number.error',
  maxLength_cardNumber: 'checkout.giftcard.number.tooLong',
  backendError_cardNumber: 'checkout.giftcard.others.message',
  required_cardPin: 'checkout.gift.card.pin.error',
  maxLength_cardPin: 'checkout.giftcard.pinNumber.tooLong',
  backendError_discountCode: 'discount.code.not.valid',
  required_discountCode: 'checkout.discountcode.error',
  backendError_password: 'hub.signin.error',
  required_password: 'login.password.required',
  required_alternativeFirstName: 'CUSTOMER.alternativeFirstName.error.missing.text',
  required_alternativeLastName: 'CUSTOMER.alternativeLastName.error.missing.text',
}

const getSpecialErrorlLabel = (type: string, fieldName: string): string | null => {
  const errorTypeKey = `${type}_${fieldName}`
  return specialErrorLabels?.[errorTypeKey] || null
}

export const getFieldErrorMessage = ({
  type,
  fieldConfigName,
  fieldName,
}: GetFieldErrorMessageInput): string => {
  const labelConfig =
    CHECKOUT_CUSTOMER_MISSING_LABEL_MAP[fieldConfigName]?.config || fieldConfigName
  const specialCaseLabel = getSpecialErrorlLabel(type, fieldName)
  if (specialCaseLabel) {
    return specialCaseLabel
  }
  const defaultLabelsMap = {
    pattern: `${labelConfig}.${fieldName}.error.regex.text`,
    required: `${labelConfig}.${fieldName}.error.missing.text`,
    minLength: `${labelConfig}.${fieldName}.error.min.text`,
    maxLength: 'CHECKOUTADDRESS.line.maxlength.error',
  }

  return defaultLabelsMap[type] || defaultLabelsMap.pattern
}
